import { render, staticRenderFns } from "./PasienRawat.vue?vue&type=template&id=14b69674&scoped=true"
import script from "./PasienRawat.vue?vue&type=script&lang=js"
export * from "./PasienRawat.vue?vue&type=script&lang=js"
import style0 from "./PasienRawat.vue?vue&type=style&index=0&id=14b69674&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b69674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14b69674')) {
      api.createRecord('14b69674', component.options)
    } else {
      api.reload('14b69674', component.options)
    }
    module.hot.accept("./PasienRawat.vue?vue&type=template&id=14b69674&scoped=true", function () {
      api.rerender('14b69674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/PasienRawat.vue"
export default component.exports